module.exports = __webpack_public_path__ + "static/assets/7d7ec7dadfa937027f379bb16b60bbf4.png";